<div class="min-h-screen flex items-center justify-center relative bg-cover bg-center bg-no-repeat p-4" [style.background-image]="'url(' + backgroundImageUrl + ')'">
  <div class="absolute inset-0 bg-white/10 backdrop-blur-[2px]"></div>
  
  <div class="relative z-10 w-full max-w-[450px]">
    <div class="bg-white rounded-xl p-10 sm:p-8 sm:px-6 shadow-2xl flex flex-col gap-6 relative overflow-visible">
      <!-- Logo -->
      <div class="flex justify-center items-center mt-0 p-0 relative z-10 min-h-[60px] sm:min-h-[50px] max-h-[80px] sm:max-h-[70px] overflow-visible w-full">
        <app-image-tag 
          [src]="logoUrl" 
          [alt]="'Platform Admin Logo'" 
          class="h-8 w-8"
          [preventDownload]="true">
        </app-image-tag>
      </div>

      <!-- Title -->
      <div class="text-center">
        <h1 class="text-2xl font-bold text-gray-900 mb-1">Forgot Password</h1>
        <p class="text-sm text-gray-600">Platform Admin</p>
      </div>

      @if (!emailSent()) {
        <!-- Forgot Password Form -->
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
          <div class="bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
            <p class="text-sm text-blue-700">
              Enter your email address and we'll send you a link to reset your password.
            </p>
          </div>

          <!-- Email Input -->
          <app-input
            type="email"
            label="Email"
            [required]="true"
            placeholder="Enter your admin email"
            formControlName="email"
            id="email"
            name="email">
          </app-input>

          <!-- Submit Button -->
          <app-button
            type="submit"
            variant="primary"
            [fullWidth]="true"
            [loading]="isLoading()"
            [disabled]="isLoading()">
            {{ isLoading() ? 'Sending...' : 'Send Reset Link' }}
          </app-button>

          <!-- Back to Login Link -->
          <a 
            (click)="goToLogin(); $event.preventDefault()" 
            class="text-center text-primary-600 underline text-sm cursor-pointer transition-colors duration-200 hover:text-primary-700">
            Back to Login
          </a>
        </form>
      } @else {
        <!-- Success Message -->
        <div class="flex flex-col items-center gap-4 text-center">
          <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div>
            <h2 class="text-xl font-semibold text-gray-900 mb-2">Email Sent!</h2>
            <p class="text-sm text-gray-600 mb-4">
              We've sent a password reset link to <strong>{{ forgotPasswordForm.get('email')?.value }}</strong>
            </p>
            <p class="text-xs text-gray-500 mb-4">
              Please check your email and click on the link to reset your password. The link will expire in 24 hours.
            </p>
          </div>
          <app-button
            type="button"
            variant="primary"
            [fullWidth]="true"
            (click)="goToLogin()">
            Back to Login
          </app-button>
        </div>
      }

      <!-- Footer -->
      <div class="flex flex-col items-center gap-2 mt-4 pt-4 border-t border-gray-200">
        <app-image-tag 
          [src]="logoUrl" 
          [alt]="'Platform Admin Logo'" 
          class="h-8 w-8 object-contain"
          [preventDownload]="true">
        </app-image-tag>
        <p class="text-xs text-gray-500 m-0">Powered by HCMS Platform</p>
      </div>
    </div>
  </div>
</div>


